// Page projets
function Projects() {
    const projects = [
        { title: 'To-Do App', description: 'Mood-based task manager with weather API integration and Handlebars templating.', tech: ['Node.js', 'Express', 'Handlebars'] },
        { title: 'REST API (MongoDB)', description: 'Backend API with full CRUD operations using MongoDB and Mongoose.', tech: ['Node.js', 'Express', 'MongoDB'] },
        { title: 'REST API (PostgreSQL)', description: 'Backend API converted to PostgreSQL with SQL queries and foreign keys.', tech: ['Node.js', 'Express', 'PostgreSQL'] },
        { title: 'Portfolio', description: 'Personal portfolio designed in Figma and built with TailwindCSS.', tech: ['TailwindCSS', 'Figma', 'Express'] },
        { title: 'Blog Platform', description: 'Full-stack blog with React frontend and PostgreSQL backend.', tech: ['React', 'Node.js', 'PostgreSQL'] },
    ];

    return (
        <section className="max-w-4xl mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10">Projects</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {projects.map((project, i) => (
                    <div key={i} className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-blue-500 transition">
                        <h3 className="text-lg font-bold mb-2">{project.title}</h3>
                        <p className="text-gray-400 text-sm mb-4">{project.description}</p>
                        <div className="flex flex-wrap gap-2">
                            {project.tech.map(t => (
                                <span key={t} className="bg-blue-900 text-blue-300 px-3 py-1 rounded-full text-xs">{t}</span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Projects;